import React from 'react';
import { Button, Checkbox } from 'antd';
import intl from 'react-intl-universal';
import './index.scss';
import SignatureVerification from './SignatureVerification.dialog';
import { store } from "Store/store.index";

export default class Signature extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSignatureDlg: false,
      verifyRule: store.appStore.getVerifySignatureRule(),
      signNow:(window.localStorage.getItem('SignLater')||"false")=='false'
    }

    this.showSignatureVerification = this.showSignatureVerification.bind(this);
    this.closeSignatureVerification = this.closeSignatureVerification.bind(this);
  }

  showSignatureVerification(){
    this.setState({
        showSignatureDlg: true
    })
  }
  closeSignatureVerification(type, rule = {}){
    let _rule = { ...this.state.verifyRule, ...(type === 'ok' ? rule : {})}
    this.setState({
        verifyRule: _rule,
        showSignatureDlg:false
    })
  }

  getVerifySignatureRule() {
    return this.state.verifyRule;
  }
  onChangeSignNow=(e)=>{
    window.localStorage.setItem('SignLater',!e.target.checked)
    this.setState({signNow:e.target.checked})
  }
  render() {

    let { showSignatureDlg, verifyRule,signNow } = this.state;

    const signatureTitle = intl.formatMessage({ id: 'Preferences.Content.Signature.Title' });
    const signatureContent = intl.formatMessage({ id: 'Preferences.Content.Signature.content' });
    const showSettingBtn = intl.formatMessage({ id: 'Preferences.Content.Signature.button' });

    return (
      <div className="signature-panel">
         <div className="title signature-title">{signatureTitle}</div>
         <div className="container">
            <div className="signature-content sign-now">
                <Checkbox onChange={this.onChangeSignNow} checked={signNow}>{intl.get('Preferences.Content.Signature.signAfter')}</Checkbox>
            </div>
            <div className="sep"></div>
            <div className="signature-content">
                <div className="signature-content-area">{signatureContent}</div>
                <div className="signature-content-btn">
                    <Button onClick={this.showSignatureVerification}>{showSettingBtn} </Button>
                </div>
            </div>
          </div>
          <SignatureVerification visible={showSignatureDlg} close={this.closeSignatureVerification} config={verifyRule}/>
      </div>
    );
  }
}
